function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Logo Desktop",
    xmlns: "http://www.w3.org/2000/svg",
    width: 157.87,
    height: 44,
    viewBox: "0 0 157.87 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 488"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 994",
    d: "M224.283 112.688a18.593 18.593 0 0 0-7.517-1.974c-2.409 0-3.625.874-3.625 2.2 0 1.4 1.7 1.749 3.844 2.074l2.091.324c5.11.8 7.956 3.147 7.956 7.245 0 5-3.99 8.218-10.826 8.218-3.212 0-7.42-.624-10.485-2.847l2.506-4.946a13.548 13.548 0 0 0 8.028 2.372c2.943 0 4.355-.849 4.355-2.274 0-1.174-1.192-1.823-3.917-2.223l-1.922-.275c-5.449-.774-8.151-3.222-8.151-7.344 0-4.972 3.747-7.92 9.951-7.92a20.659 20.659 0 0 1 9.853 2.3z",
    transform: "translate(-166.325 -96.143)",
    style: {
      fill: "#1c1c1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 995",
    d: "M275.279 104.37h-8.539v8.844c0 3.023 1.557 4.122 3.528 4.122a9.061 9.061 0 0 0 4.427-1.573l2.337 5.1a12.929 12.929 0 0 1-7.81 2.547c-5.838 0-8.831-3.4-8.831-9.667V91.381h6.35v7.194h8.539z",
    transform: "translate(-195.898 -88.776)",
    style: {
      fill: "#1c1c1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 996",
    d: "M322.215 117.981a19.186 19.186 0 0 1-.122 2.2H305.38a5.726 5.726 0 0 0 6.058 5.021 9.39 9.39 0 0 0 5.96-2.323l3.722 4.2a14.081 14.081 0 0 1-10.047 3.672c-7.226 0-12.237-5.046-12.237-12.665s4.866-12.816 11.921-12.816c6.787-.005 11.433 5.166 11.458 12.711zm-16.815-2.248h10.437c-.584-3.1-2.409-4.846-5.134-4.846-2.988 0-4.739 1.848-5.303 4.846z",
    transform: "translate(-216.694 -96.115)",
    style: {
      fill: "#1c1c1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 997",
    d: "M383.357 118.006c0 7.27-4.915 12.74-11.41 12.74a8.534 8.534 0 0 1-6.934-3.147v12.516h-6.325v-34.2h6.2v2.673a8.46 8.46 0 0 1 7.03-3.323c6.525 0 11.439 5.471 11.439 12.741zm-18.66 0c0 3.822 2.457 6.67 6.058 6.67 3.747 0 6.082-2.973 6.082-6.67s-2.335-6.67-6.082-6.67c-3.6 0-6.055 2.847-6.055 6.67z",
    transform: "translate(-249.071 -96.115)",
    style: {
      fill: "#1c1c1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 998",
    d: "M435.94 112.688a18.593 18.593 0 0 0-7.517-1.974c-2.409 0-3.625.874-3.625 2.2 0 1.4 1.7 1.749 3.844 2.074l2.092.324c5.109.8 7.956 3.147 7.956 7.245 0 5-3.99 8.218-10.826 8.218-3.212 0-7.42-.624-10.485-2.847l2.505-4.946a13.55 13.55 0 0 0 8.029 2.372c2.943 0 4.355-.849 4.355-2.274 0-1.174-1.192-1.823-3.917-2.223l-1.922-.275c-5.45-.774-8.151-3.222-8.151-7.344 0-4.972 3.746-7.92 9.95-7.92a20.659 20.659 0 0 1 9.853 2.3z",
    transform: "translate(-280.819 -96.143)",
    style: {
      fill: "#1c1c1c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 489"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 999",
    d: "M135.932 101.543c-.1 1.263-.217 2.284-.256 3.308a2.227 2.227 0 0 0 .755 2.161 1.771 1.771 0 0 1 .243 2.059 1.012 1.012 0 0 1-1.625.256 5.673 5.673 0 0 1-1.011-1.41 8.262 8.262 0 0 1-.4-1.051c-.388-.935-.6-1.035-1.37-.438a12.124 12.124 0 0 1-5.525 2.181 6.619 6.619 0 0 1-4.131-.692 4.455 4.455 0 0 1-2.257-2.977 11.128 11.128 0 0 1 1.5-9.433 27.813 27.813 0 0 1 9.116-8.543 8.472 8.472 0 0 1 2.768-1.082 1.884 1.884 0 0 1 1.972 2.4c-.213.815-.605 1.09-1.463.8a1.713 1.713 0 0 0-1.617.38 54.545 54.545 0 0 0-5.061 3.829A26.029 26.029 0 0 0 124 97.36a9.006 9.006 0 0 0-1.729 5.287 2.729 2.729 0 0 0 2.383 3.08 7.255 7.255 0 0 0 3.585-.182 8.529 8.529 0 0 0 4.036-2.406c.966-1 .728-1.848-.581-2.251-.449-.139-.929-.17-1.391-.267a1.623 1.623 0 0 1-1.414-1.8c.092-.834.655-1.277 1.76-1.158 1.3.14 2.594.4 3.883.648a1.628 1.628 0 0 1 1.177 1.391 13.1 13.1 0 0 1 .223 1.841z",
    transform: "translate(-119.901 -85.854)",
    style: {
      fill: "#1c1c1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1000",
    d: "M169.061 103.431c0-.248-.016-.68 0-1.111s.076-.908.6-1.009c.608-.116.838.354.987.827.193.614.346 1.243.489 1.871.323 1.415.345 1.44 1.784 1.359.315-.018.63-.064.944-.055a1.383 1.383 0 0 1 1.424 1.549c-.014.753-.455 1.151-1.364 1.231-2.046.181-2.082.187-1.75 2.291.2 1.275.55 2.525.8 3.794a1.866 1.866 0 0 1-.02 1.1 1.369 1.369 0 0 1-.863.586c-.523.114-.87-.221-1.095-.717s-.511-.991-.77-1.485a8.956 8.956 0 0 1-.883 1.295 5.98 5.98 0 0 1-5.305 1.913 4.958 4.958 0 0 1-3.7-2.972c-.395-.758-.844-1.493-1.164-2.283a3.065 3.065 0 0 1-.224-1.537c.158-1 .484-1.976.709-2.968.32-1.41.992-2.587 2.435-2.879a3.432 3.432 0 0 1 3.874 1.517c.422.679.76.81 1.3.189a1.084 1.084 0 0 1 .422-.2c1.453-.584 1.453-.583 1.37-2.306zm-3.745 11.008c.891-.347 1.811-.678 2.708-1.067.379-.165.7-.477 1.065-.671.354-.186.968-.221 1.061-.478a3.178 3.178 0 0 0-.107-1.411c-.065-.423-.217-.836-.248-1.26a1.193 1.193 0 0 0-1.347-1.222 3.493 3.493 0 0 1-.931-.115.872.872 0 0 0-1.235.593 4.993 4.993 0 0 1-2.756 2.7c-1.459.715-1.484 1.376-.074 2.251a9.987 9.987 0 0 0 1.863.68zm-3.038-5.235c.613-.392 1.2-.717 1.723-1.128a.951.951 0 0 0 .342-.773 1.1 1.1 0 0 0-.689-.553c-.8-.243-2.016 1-1.848 1.88.032.164.235.295.472.57z",
    transform: "translate(-141.01 -94.016)",
    style: {
      fill: "#1c1c1c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDesktop);
export default __webpack_public_path__ + "static/media/logo-desktop.b8e3da8ce403a7663881c1147981739c.svg";
export { ForwardRef as ReactComponent };